<template>
  <div class="flex flex-col bg-lightpurple min-h-screen">
    <page-header :hide_navbar="hide_navbar" :show-bg-white="showBgWhite"></page-header>
    <contact-index></contact-index>
  </div>
</template>
<script>
import PageHeader from "./components/header.vue";
import PageFooter from "./components/footer.vue";
import ContactIndex from "./sections/contact_page/contact_index.vue"

export default {
  name: "contact",
  props: {
    hide_navbar: String,
  },
  components: { PageHeader, PageFooter, ContactIndex},
  data() {
    return {
        showBgWhite: "no",
    };
  },
}
</script>
<style lang="scss" scoped>
.x {
    color: red
}
.bg-lightpurple{
  background-color: #f4f3fa;
}
</style>